import React from "react";
import {
    Button,
    Row,
    Container,
    Col,
} from "react-bootstrap";

function NoRoute() {

    return (



        <Container className="p-5" style={{ minHeight: '100%' }}>

            <Row className="m-auto">
                <h2 className="text-light text-center">You need a link from your PinStack rep.</h2>
            </Row>
        </Container>

    )
}
export default NoRoute;